export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total a deducir"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comisión"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A acreditar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se puede calcular la cantidad"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fondos insuficientes para el pago"])}
}